// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { chipClasses } from '@mui/material/Chip';
import { rem } from '../../tokens/conversions';
import { chipColors } from './chipColors';
export var Chip = function(mode) {
    var c = chipColors(mode);
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7, _obj8, _obj9, _obj10, _obj11, _obj12, _obj13, _obj14, _obj15, _obj16, _obj17, _obj18, _obj19, _obj20, _obj21, _obj22, _obj23, _obj24, _obj25, _obj26, _obj27, _obj28, _obj29, _obj30, _obj31, _obj32, _obj33, _obj34, _obj35, _obj36, _obj37, _obj38, _obj39, _obj40, _obj41, _obj42;
    var override = {
        MuiChip: {
            styleOverrides: {
                root: (_obj16 = {
                    fontWeight: 600,
                    padding: "".concat(rem(4), " ").concat(rem(8)),
                    borderRadius: rem(48),
                    gap: rem(8)
                }, _define_property(_obj16, "& .".concat(chipClasses.label), {
                    paddingLeft: rem(0),
                    paddingRight: rem(0)
                }), _define_property(_obj16, "& .".concat(chipClasses.icon), {
                    margin: 0
                }), _define_property(_obj16, "& .".concat(chipClasses.deleteIcon), {
                    margin: 0,
                    color: 'inherit'
                }), _define_property(_obj16, "&.".concat(chipClasses.sizeMedium), (_obj = {
                    fontSize: rem(14),
                    lineHeight: rem(18),
                    minHeight: rem(28),
                    height: 'auto'
                }, _define_property(_obj, "& .".concat(chipClasses.icon), {
                    fontSize: rem(16)
                }), _define_property(_obj, "& .".concat(chipClasses.deleteIcon), {
                    fontSize: rem(20)
                }), _obj)), _define_property(_obj16, "&.".concat(chipClasses.sizeSmall), (_obj1 = {
                    fontSize: rem(12),
                    lineHeight: rem(16),
                    minHeight: rem(20),
                    height: 'auto',
                    padding: "".concat(rem(4), " ").concat(rem(6)),
                    gap: rem(4)
                }, _define_property(_obj1, "& .".concat(chipClasses.icon), {
                    fontSize: rem(12)
                }), _define_property(_obj1, "& .".concat(chipClasses.deleteIcon), {
                    fontSize: rem(16)
                }), _obj1)), _define_property(_obj16, "&.".concat(chipClasses.outlined), (_obj8 = {}, _define_property(_obj8, "& .".concat(chipClasses.icon), {
                    color: c.outlined.default.icon
                }), _define_property(_obj8, "& .".concat(chipClasses.label), {
                    color: c.outlined.default.text
                }), _define_property(_obj8, "& .".concat(chipClasses.deleteIcon), {
                    color: c.outlined.default.icon
                }), _define_property(_obj8, "&.".concat(chipClasses.colorInfo), (_obj2 = {
                    border: "1px solid ".concat(c.outlined.info.border)
                }, _define_property(_obj2, "& .".concat(chipClasses.icon), {
                    color: c.outlined.info.icon
                }), _define_property(_obj2, "& .".concat(chipClasses.label), {
                    color: c.outlined.info.text
                }), _define_property(_obj2, "& .".concat(chipClasses.deleteIcon), {
                    color: c.outlined.info.icon
                }), _obj2)), _define_property(_obj8, "&.".concat(chipClasses.colorSuccess), (_obj3 = {
                    border: "1px solid ".concat(c.outlined.success.border)
                }, _define_property(_obj3, "& .".concat(chipClasses.icon), {
                    color: c.outlined.success.icon
                }), _define_property(_obj3, "& .".concat(chipClasses.label), {
                    color: c.outlined.success.text
                }), _define_property(_obj3, "& .".concat(chipClasses.deleteIcon), {
                    color: c.outlined.success.icon
                }), _obj3)), _define_property(_obj8, "&.".concat(chipClasses.colorError), (_obj4 = {
                    border: "1px solid ".concat(c.outlined.error.border)
                }, _define_property(_obj4, "& .".concat(chipClasses.label), {
                    color: c.outlined.error.text
                }), _define_property(_obj4, "& .".concat(chipClasses.icon), {
                    color: c.outlined.error.icon
                }), _define_property(_obj4, "& .".concat(chipClasses.deleteIcon), {
                    color: c.outlined.error.icon
                }), _obj4)), _define_property(_obj8, "&.".concat(chipClasses.colorWarning), (_obj5 = {
                    border: "1px solid ".concat(c.outlined.warning.border)
                }, _define_property(_obj5, "& .".concat(chipClasses.label), {
                    color: c.outlined.warning.text
                }), _define_property(_obj5, "& .".concat(chipClasses.icon), {
                    color: c.outlined.warning.icon
                }), _define_property(_obj5, "& .".concat(chipClasses.deleteIcon), {
                    color: c.outlined.warning.icon
                }), _obj5)), _define_property(_obj8, "&.".concat(chipClasses.colorSecondary), (_obj6 = {
                    border: "1px solid ".concat(c.outlined.special.border)
                }, _define_property(_obj6, "& .".concat(chipClasses.icon), {
                    color: c.outlined.special.icon
                }), _define_property(_obj6, "& .".concat(chipClasses.label), {
                    color: c.outlined.special.text
                }), _define_property(_obj6, "& .".concat(chipClasses.deleteIcon), {
                    color: c.outlined.special.icon
                }), _obj6)), _define_property(_obj8, "&.".concat(chipClasses.colorDefault), (_obj7 = {
                    border: "1px solid ".concat(c.outlined.default.border)
                }, _define_property(_obj7, "& .".concat(chipClasses.icon), {
                    color: c.outlined.default.icon
                }), _define_property(_obj7, "& .".concat(chipClasses.label), {
                    color: c.outlined.default.text
                }), _obj7)), _obj8)), _define_property(_obj16, "&.".concat(chipClasses.filled), (_obj15 = {
                    color: c.bold.text
                }, _define_property(_obj15, "&.".concat(chipClasses.colorInfo), (_obj9 = {
                    backgroundColor: c.bold.info.background
                }, _define_property(_obj9, "& .".concat(chipClasses.icon), {
                    color: c.bold.info.icon
                }), _define_property(_obj9, "& .".concat(chipClasses.label), {
                    color: c.bold.info.text
                }), _define_property(_obj9, "& .".concat(chipClasses.deleteIcon), {
                    color: c.bold.info.icon
                }), _obj9)), _define_property(_obj15, "&.".concat(chipClasses.colorSuccess), (_obj10 = {
                    backgroundColor: c.bold.success.background,
                    color: c.bold.success.text
                }, _define_property(_obj10, "& .".concat(chipClasses.icon), {
                    color: c.bold.success.icon
                }), _define_property(_obj10, "& .".concat(chipClasses.label), {
                    color: c.bold.success.text
                }), _define_property(_obj10, "& .".concat(chipClasses.deleteIcon), {
                    color: c.bold.success.icon
                }), _obj10)), _define_property(_obj15, "&.".concat(chipClasses.colorError), (_obj11 = {
                    backgroundColor: c.bold.error.background
                }, _define_property(_obj11, "& .".concat(chipClasses.icon), {
                    color: c.bold.error.icon
                }), _define_property(_obj11, "& .".concat(chipClasses.label), {
                    color: c.bold.error.text
                }), _define_property(_obj11, "& .".concat(chipClasses.deleteIcon), {
                    color: c.bold.error.icon
                }), _obj11)), _define_property(_obj15, "&.".concat(chipClasses.colorWarning), (_obj12 = {
                    backgroundColor: c.bold.warning.background,
                    color: c.bold.warning.text
                }, _define_property(_obj12, "& .".concat(chipClasses.icon), {
                    color: c.bold.warning.icon
                }), _define_property(_obj12, "& .".concat(chipClasses.label), {
                    color: c.bold.warning.text
                }), _define_property(_obj12, "& .".concat(chipClasses.deleteIcon), {
                    color: c.bold.warning.icon
                }), _obj12)), _define_property(_obj15, "&.".concat(chipClasses.colorPrimary), (_obj13 = {
                    backgroundColor: c.bold.default.background,
                    color: c.bold.default.text
                }, _define_property(_obj13, "& .".concat(chipClasses.icon), {
                    color: c.bold.default.icon
                }), _define_property(_obj13, "& .".concat(chipClasses.label), {
                    color: c.bold.default.text
                }), _define_property(_obj13, "& .".concat(chipClasses.deleteIcon), {
                    color: c.bold.default.icon
                }), _obj13)), _define_property(_obj15, "&.".concat(chipClasses.colorSecondary), (_obj14 = {
                    backgroundColor: c.bold.special.background
                }, _define_property(_obj14, "& .".concat(chipClasses.icon), {
                    color: c.bold.special.icon
                }), _define_property(_obj14, "& .".concat(chipClasses.label), {
                    color: c.bold.special.text
                }), _define_property(_obj14, "& .".concat(chipClasses.deleteIcon), {
                    color: c.bold.special.icon
                }), _obj14)), _obj15)), _obj16)
            },
            variants: [
                {
                    // MuiChip applies its own default filled background (rgba(0,0,0,0.08)) for
                    // colorDefault via a specificity that beats styleOverrides.root nesting.
                    // Moving this to variants gives it the && boost needed to win.
                    props: {
                        variant: 'filled',
                        color: 'default'
                    },
                    style: (_obj17 = {
                        backgroundColor: c.bold.default.background,
                        color: c.bold.default.text
                    }, _define_property(_obj17, "& .".concat(chipClasses.icon), {
                        color: c.bold.default.icon
                    }), _define_property(_obj17, "& .".concat(chipClasses.label), {
                        color: c.bold.default.text
                    }), _define_property(_obj17, "& .".concat(chipClasses.deleteIcon), {
                        color: c.bold.default.icon
                    }), _obj17)
                },
                {
                    props: {
                        size: 'large'
                    },
                    style: _define_property({}, "&.".concat(chipClasses.root), (_obj18 = {
                        fontSize: rem(14),
                        lineHeight: rem(18),
                        minHeight: rem(36),
                        height: 'auto',
                        padding: "".concat(rem(8), " ").concat(rem(12))
                    }, _define_property(_obj18, "& .".concat(chipClasses.icon), {
                        fontSize: rem(16)
                    }), _define_property(_obj18, "& .".concat(chipClasses.deleteIcon), {
                        fontSize: rem(20)
                    }), _obj18))
                },
                {
                    props: {
                        variant: 'soft'
                    },
                    style: _define_property({}, "&.".concat(chipClasses.root), (_obj24 = {
                        backgroundColor: c.filled.default.background,
                        border: 'none'
                    }, _define_property(_obj24, "& .".concat(chipClasses.label), {
                        color: c.filled.default.text
                    }), _define_property(_obj24, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.default.icon
                    }), _define_property(_obj24, "&.".concat(chipClasses.colorInfo), (_obj19 = {
                        backgroundColor: c.filled.info.background
                    }, _define_property(_obj19, "& .".concat(chipClasses.icon), {
                        color: c.filled.info.icon
                    }), _define_property(_obj19, "& .".concat(chipClasses.label), {
                        color: c.filled.info.text
                    }), _define_property(_obj19, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.info.icon
                    }), _obj19)), _define_property(_obj24, "&.".concat(chipClasses.colorSuccess), (_obj20 = {
                        backgroundColor: c.filled.success.background
                    }, _define_property(_obj20, "& .".concat(chipClasses.icon), {
                        color: c.filled.success.icon
                    }), _define_property(_obj20, "& .".concat(chipClasses.label), {
                        color: c.filled.success.text
                    }), _define_property(_obj20, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.success.icon
                    }), _obj20)), _define_property(_obj24, "&.".concat(chipClasses.colorError), (_obj21 = {
                        backgroundColor: c.filled.error.background
                    }, _define_property(_obj21, "& .".concat(chipClasses.icon), {
                        color: c.filled.error.icon
                    }), _define_property(_obj21, "& .".concat(chipClasses.label), {
                        color: c.filled.error.text
                    }), _define_property(_obj21, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.error.icon
                    }), _obj21)), _define_property(_obj24, "&.".concat(chipClasses.colorWarning), (_obj22 = {
                        backgroundColor: c.filled.warning.background
                    }, _define_property(_obj22, "& .".concat(chipClasses.icon), {
                        color: c.filled.warning.icon
                    }), _define_property(_obj22, "& .".concat(chipClasses.label), {
                        color: c.filled.warning.text
                    }), _define_property(_obj22, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.warning.icon
                    }), _obj22)), _define_property(_obj24, "&.".concat(chipClasses.colorSecondary), (_obj23 = {
                        backgroundColor: c.filled.special.background
                    }, _define_property(_obj23, "& .".concat(chipClasses.icon), {
                        color: c.filled.special.icon
                    }), _define_property(_obj23, "& .".concat(chipClasses.label), {
                        color: c.filled.special.text
                    }), _define_property(_obj23, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.special.icon
                    }), _obj23)), _define_property(_obj24, "&.".concat(chipClasses.colorPrimary), _define_property({
                        backgroundColor: c.filled.default.background
                    }, "& .".concat(chipClasses.icon), {
                        color: c.filled.default.icon
                    })), _define_property(_obj24, "&.".concat(chipClasses.colorDefault), _define_property({
                        backgroundColor: c.filled.default.background
                    }, "& .".concat(chipClasses.icon), {
                        color: c.filled.default.icon
                    })), _obj24))
                },
                {
                    props: {
                        variant: 'boldOutlined'
                    },
                    style: _define_property({}, "&.".concat(chipClasses.root), (_obj31 = {
                        backgroundColor: 'transparent',
                        border: "1px solid ".concat(c.boldOutlined.default.border)
                    }, _define_property(_obj31, "& .".concat(chipClasses.label), {
                        color: c.boldOutlined.default.text
                    }), _define_property(_obj31, "& .".concat(chipClasses.icon), {
                        color: c.boldOutlined.default.icon
                    }), _define_property(_obj31, "& .".concat(chipClasses.deleteIcon), {
                        color: c.boldOutlined.default.icon
                    }), _define_property(_obj31, "&.".concat(chipClasses.colorInfo), (_obj25 = {
                        border: "1px solid ".concat(c.boldOutlined.info.border)
                    }, _define_property(_obj25, "& .".concat(chipClasses.icon), {
                        color: c.boldOutlined.info.icon
                    }), _define_property(_obj25, "& .".concat(chipClasses.label), {
                        color: c.boldOutlined.info.text
                    }), _define_property(_obj25, "& .".concat(chipClasses.deleteIcon), {
                        color: c.boldOutlined.info.icon
                    }), _obj25)), _define_property(_obj31, "&.".concat(chipClasses.colorSuccess), (_obj26 = {
                        border: "1px solid ".concat(c.boldOutlined.success.border)
                    }, _define_property(_obj26, "& .".concat(chipClasses.icon), {
                        color: c.boldOutlined.success.icon
                    }), _define_property(_obj26, "& .".concat(chipClasses.label), {
                        color: c.boldOutlined.success.text
                    }), _define_property(_obj26, "& .".concat(chipClasses.deleteIcon), {
                        color: c.boldOutlined.success.icon
                    }), _obj26)), _define_property(_obj31, "&.".concat(chipClasses.colorError), (_obj27 = {
                        border: "1px solid ".concat(c.boldOutlined.error.border)
                    }, _define_property(_obj27, "& .".concat(chipClasses.icon), {
                        color: c.boldOutlined.error.icon
                    }), _define_property(_obj27, "& .".concat(chipClasses.label), {
                        color: c.boldOutlined.error.text
                    }), _define_property(_obj27, "& .".concat(chipClasses.deleteIcon), {
                        color: c.boldOutlined.error.icon
                    }), _obj27)), _define_property(_obj31, "&.".concat(chipClasses.colorWarning), (_obj28 = {
                        border: "1px solid ".concat(c.boldOutlined.warning.border)
                    }, _define_property(_obj28, "& .".concat(chipClasses.icon), {
                        color: c.boldOutlined.warning.icon
                    }), _define_property(_obj28, "& .".concat(chipClasses.label), {
                        color: c.boldOutlined.warning.text
                    }), _define_property(_obj28, "& .".concat(chipClasses.deleteIcon), {
                        color: c.boldOutlined.warning.icon
                    }), _obj28)), _define_property(_obj31, "&.".concat(chipClasses.colorSecondary), (_obj29 = {
                        border: "1px solid ".concat(c.boldOutlined.special.border)
                    }, _define_property(_obj29, "& .".concat(chipClasses.icon), {
                        color: c.boldOutlined.special.icon
                    }), _define_property(_obj29, "& .".concat(chipClasses.label), {
                        color: c.boldOutlined.special.text
                    }), _define_property(_obj29, "& .".concat(chipClasses.deleteIcon), {
                        color: c.boldOutlined.special.icon
                    }), _obj29)), _define_property(_obj31, "&.".concat(chipClasses.colorDefault), (_obj30 = {
                        border: "1px solid ".concat(c.boldOutlined.default.border)
                    }, _define_property(_obj30, "& .".concat(chipClasses.icon), {
                        color: c.boldOutlined.default.icon
                    }), _define_property(_obj30, "& .".concat(chipClasses.label), {
                        color: c.boldOutlined.default.text
                    }), _obj30)), _obj31))
                },
                {
                    props: {
                        variant: 'textOnly'
                    },
                    style: _define_property({}, "&.".concat(chipClasses.root), (_obj37 = {
                        backgroundColor: 'transparent',
                        border: 'none'
                    }, _define_property(_obj37, "& .".concat(chipClasses.label), {
                        color: c.filled.default.text
                    }), _define_property(_obj37, "& .".concat(chipClasses.icon), {
                        color: c.filled.default.icon
                    }), _define_property(_obj37, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.default.icon
                    }), _define_property(_obj37, "&.".concat(chipClasses.colorInfo), (_obj32 = {}, _define_property(_obj32, "& .".concat(chipClasses.icon), {
                        color: c.filled.info.icon
                    }), _define_property(_obj32, "& .".concat(chipClasses.label), {
                        color: c.filled.info.text
                    }), _define_property(_obj32, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.info.icon
                    }), _obj32)), _define_property(_obj37, "&.".concat(chipClasses.colorSuccess), (_obj33 = {}, _define_property(_obj33, "& .".concat(chipClasses.icon), {
                        color: c.filled.success.icon
                    }), _define_property(_obj33, "& .".concat(chipClasses.label), {
                        color: c.filled.success.text
                    }), _define_property(_obj33, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.success.icon
                    }), _obj33)), _define_property(_obj37, "&.".concat(chipClasses.colorError), (_obj34 = {}, _define_property(_obj34, "& .".concat(chipClasses.icon), {
                        color: c.filled.error.icon
                    }), _define_property(_obj34, "& .".concat(chipClasses.label), {
                        color: c.filled.error.text
                    }), _define_property(_obj34, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.error.icon
                    }), _obj34)), _define_property(_obj37, "&.".concat(chipClasses.colorWarning), (_obj35 = {}, _define_property(_obj35, "& .".concat(chipClasses.icon), {
                        color: c.filled.warning.icon
                    }), _define_property(_obj35, "& .".concat(chipClasses.label), {
                        color: c.filled.warning.text
                    }), _define_property(_obj35, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.warning.icon
                    }), _obj35)), _define_property(_obj37, "&.".concat(chipClasses.colorSecondary), (_obj36 = {}, _define_property(_obj36, "& .".concat(chipClasses.icon), {
                        color: c.filled.special.icon
                    }), _define_property(_obj36, "& .".concat(chipClasses.label), {
                        color: c.filled.special.text
                    }), _define_property(_obj36, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.special.icon
                    }), _obj36)), _define_property(_obj37, "&.".concat(chipClasses.colorDefault), _define_property({}, "& .".concat(chipClasses.icon), {
                        color: c.filled.default.icon
                    })), _obj37))
                },
                {
                    props: {
                        dropShadow: true
                    },
                    style: {
                        boxShadow: '0px 2px 6px 0px rgba(0,0,0,0.25)'
                    }
                },
                {
                    props: {
                        cornerShape: 'square'
                    },
                    style: {
                        borderRadius: rem(4)
                    }
                },
                {
                    props: {
                        variant: 'soft',
                        color: 'gray'
                    },
                    style: _define_property({}, "&.".concat(chipClasses.root), (_obj38 = {
                        backgroundColor: c.filled.gray.background
                    }, _define_property(_obj38, "& .".concat(chipClasses.icon), {
                        color: c.filled.gray.icon
                    }), _define_property(_obj38, "& .".concat(chipClasses.label), {
                        color: c.filled.gray.text
                    }), _define_property(_obj38, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.gray.icon
                    }), _obj38))
                },
                {
                    props: {
                        variant: 'outlined',
                        color: 'gray'
                    },
                    style: (_obj39 = {
                        border: "".concat(rem(1), " solid ").concat(c.outlined.gray.border)
                    }, _define_property(_obj39, "& .".concat(chipClasses.icon), {
                        color: c.outlined.gray.icon
                    }), _define_property(_obj39, "& .".concat(chipClasses.label), {
                        color: c.outlined.gray.text
                    }), _define_property(_obj39, "& .".concat(chipClasses.deleteIcon), {
                        color: c.outlined.gray.icon
                    }), _obj39)
                },
                {
                    props: {
                        variant: 'filled',
                        color: 'gray'
                    },
                    style: (_obj40 = {
                        backgroundColor: c.bold.gray.background,
                        color: c.bold.gray.text
                    }, _define_property(_obj40, "& .".concat(chipClasses.icon), {
                        color: c.bold.gray.icon
                    }), _define_property(_obj40, "& .".concat(chipClasses.label), {
                        color: c.bold.gray.text
                    }), _define_property(_obj40, "& .".concat(chipClasses.deleteIcon), {
                        color: c.bold.gray.icon
                    }), _obj40)
                },
                {
                    props: {
                        variant: 'boldOutlined',
                        color: 'gray'
                    },
                    style: _define_property({}, "&.".concat(chipClasses.root), (_obj41 = {
                        border: "".concat(rem(1), " solid ").concat(c.boldOutlined.gray.border)
                    }, _define_property(_obj41, "& .".concat(chipClasses.icon), {
                        color: c.boldOutlined.gray.icon
                    }), _define_property(_obj41, "& .".concat(chipClasses.label), {
                        color: c.boldOutlined.gray.text
                    }), _define_property(_obj41, "& .".concat(chipClasses.deleteIcon), {
                        color: c.boldOutlined.gray.icon
                    }), _obj41))
                },
                {
                    props: {
                        variant: 'textOnly',
                        color: 'gray'
                    },
                    style: _define_property({}, "&.".concat(chipClasses.root), (_obj42 = {}, _define_property(_obj42, "& .".concat(chipClasses.icon), {
                        color: c.filled.gray.icon
                    }), _define_property(_obj42, "& .".concat(chipClasses.label), {
                        color: c.filled.gray.text
                    }), _define_property(_obj42, "& .".concat(chipClasses.deleteIcon), {
                        color: c.filled.gray.icon
                    }), _obj42))
                }
            ]
        }
    };
    return override;
};

//# sourceMappingURL=Chip.js.map